export default "__VITE_ASSET__CHbTFJK5__"